import isInResolution from "./resolutions/is-in-resolution";

/**
 * Return current resolution string
 * @param {ResolutionProps | ResolutionClusterProps} resolutions
 * @returns
 */
const getCurrentResolution = (resolutions) => {
  /** @type {keyof ResolutionObjectProps} */
  let last = "all";

  for (const resolution of resolutions.keys()) {
    if (!isInResolution(resolution)) {
      break;
    }

    last = resolution;
  }

  return last;
};

export default getCurrentResolution;
